(() => {
  const initializeSection = (section) => {
    section.querySelectorAll('[data-drjaytee-testimonial-toggle]').forEach((button) => {
      if (button.dataset.drjayteeTestimonialInitialized === 'true') return;

      const review = button.closest('[data-drjaytee-testimonial-review]');
      if (!review) return;

      button.dataset.drjayteeTestimonialInitialized = 'true';
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !isExpanded;

        review.classList.toggle('is-expanded', nextExpanded);
        button.setAttribute('aria-expanded', String(nextExpanded));
        button.textContent = nextExpanded
          ? button.dataset.readLessLabel || 'Read less'
          : button.dataset.readMoreLabel || 'Read more';
      });
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('.drjaytee-testimonials').forEach(initializeSection);
  };

  initializeAll();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
